import { http } from "./http";

export const statsApi = {
  today: () => http.get("/stats/today").then((r) => r.data),

  todayByTask: (uids = []) =>
    http.get("/stats/today/by-task", { params: { uids: (uids || []).join(",") } }).then((r) => r.data),

  // Реальный прогресс из account_groups (не сбрасывается каждый день)
  totalProgress: (taskUid) =>
    http.get(`/stats/task/${taskUid}/total-progress`).then((r) => r.data),

  // Батч для всех задач сразу
  totalProgressBatch: (uids = []) =>
    http.get("/stats/total-progress/batch", { params: { uids: (uids || []).join(",") } }).then((r) => r.data),
};
